import { CloseRounded, SearchRounded } from '@mui/icons-material'
import { Box, IconButton, InputAdornment, InputBase, styled } from '@mui/material'
import clsx from 'clsx'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import useScreenWidth from '../../hooks/useScreenWidth'

export const StyledInputAdornment = styled(InputAdornment)(({ theme }) => ({
  padding: theme.spacing(0, 1),
  height: '100%',
  position: 'absolute',
  pointerEvents: 'none',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  '&:hover, &:active, &:focus, &:focus-within': {
    color: theme.palette.grey[900],
    backgroundColor: theme.palette.grey[200],
    borderRadius: 8,
    fontWeight: 500,
    '& svg': {
      color: `${theme.palette.primary.main} !important`
    }
  },
  '&.small': {
    padding: theme.spacing(0, 1),
    transform: 'scale(0.8)',
    '& svg': {
      color: `${theme.palette.grey[300]} !important`
    }
  }
}))

export const StyledSearchInput = styled(InputBase)(({ theme }) => ({
  '&.MuiInputBase-root': {
    color: theme.palette.grey[600],
    '&.client': {
      '&:hover, &:active, &:focus, &:focus-within': {
        color: theme.palette.grey[900],
        backgroundColor: theme.palette.grey[200],
        borderRadius: 8,
        fontWeight: 500,
        '& svg': {
          color: `${theme.palette.primary.main} !important`
        }
      }
    },
    '&.admin': {
      color: theme.palette.grey[100],
      backgroundColor: theme.palette.grey[600],
      border: 'none',
      borderRadius: 4,
      '& svg': {
        color: `${theme.palette.grey[300]} !important`
      },
      '&:hover, &:active, &:focus, &:focus-within': {
        color: theme.palette.grey[50],
        backgroundColor: theme.palette.grey[700],
        border: 'none',
        borderRadius: 4,
        '& svg': {
          color: `${theme.palette.secondary.main} !important`
        }
      }
    }
  },
  '.MuiInputBase-input': {
    padding: theme.spacing(1, 1, 1, 0),
    paddingLeft: `calc(1em + ${theme.spacing(3)})`,
    '&.small': {
      fontSize: theme.typography.body2.fontSize,
      fontWeight: 400,
      '&:focus': {
        fontWeight: 500
      }
    },
    '&.header': {
      paddingLeft: `calc(1em + ${theme.spacing(4)})`,
      transition: theme.transitions.create('width'),
      width: '100%',
      [theme.breakpoints.up('sm')]: {
        width: '18ch',
        '&:focus': {
          width: '20ch'
        }
      },
      [theme.breakpoints.down('sm')]: {
        width: '0.1ch',
        '&:focus': {
          width: `calc(${window.innerWidth}px - 88px)`,
          height: 40
        }
      }
    }
  }
}))

type ContentSeacrhProps = {
  sectionName?: any
  small?: boolean
  layout?: any
  handleContentSearch?: any
}

function ContentSearch({ sectionName = null, small = false, layout = null, handleContentSearch }: ContentSeacrhProps) {
  const { t } = useTranslation(['global'])
  const isMobile = useScreenWidth(700)

  const [focusState, setfocusState] = useState<boolean | HTMLElement>(false)

  //Función que habilita el icono de cerrar input de búsqueda y el placeholder en breackpoint < 1280
  const handleCloseInput = () => {
    setfocusState(false)
  }

  const searchActive = focusState === true
  let smallSize = small === true

  return (
    <Box
      sx={[
        smallSize
          ? {
              position: 'relative',
              margin: '6px 24px',
              height: 20,
              width: 192,
              br: 4,
              '&.client': {
                backgroundColor: theme => theme.palette.grey[100],
                color: theme => theme.palette.grey[300]
              }
            }
          : {
              position: 'relative',
              backgroundColor: theme => theme.palette.grey[100],
              marginLeft: 0,
              borderRadius: 8
            }
      ]}
      className={layout}
    >
      <StyledSearchInput
        onChange={handleContentSearch}
        placeholder={isMobile ? (searchActive ? `${t('searchIn')} ${sectionName}` : '') : `${t('searchIn')} ${sectionName}`}
        classes={{
          root: clsx(smallSize ? 'small' : '', layout),
          input: clsx(smallSize ? 'small' : 'header', layout)
        }}
        id="txt-content-filter-search"
        inputProps={{ 'aria-label': 'search' }}
        startAdornment={
          <StyledInputAdornment position="start" className={clsx(layout, smallSize ? 'small' : '')}>
            <SearchRounded />
          </StyledInputAdornment>
        }
        endAdornment={
          searchActive && (
            <StyledInputAdornment position="end" className={clsx(layout, smallSize ? 'small' : '')}>
              <IconButton aria-label="toggle search close" onClick={handleCloseInput} edge="end">
                <CloseRounded />
              </IconButton>
            </StyledInputAdornment>
          )
        }
      />
    </Box>
  )
}

export default ContentSearch
